var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497.001 497.001",
    height: 512,
    viewBox: "0 0 497.001 497.001",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__36_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.001 497-70.543-5.883c-5.523 0-10-4.477-10-10l-1.934-354.611 39.317-5.389 62.447 5.872v342.894z",
    fill: "#5f6c75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.23 477-14.23 20h-76c-5.523 0-10-4.477-10-10v-360.01l8.266-4.523 6.734 4.523v344.01c0 3.314 2.686 6 6 6z",
    fill: "#4e5a61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.001 497 73.776-2.862c5.523 0 10-4.477 10-10l2.224-7.138v-350.01l-51.032-5.617-58.514 5.617v353.617z",
    fill: "#5f6c75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421 471v-344.01l-16-4.596-27.55 4.596v333.62 20l23.55 16.39h20 56c5.523 0 10-4.477 10-10v-10h-60c-3.313 0-6-2.686-6-6z",
    fill: "#4e5a61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.001 339.99h43c2.761 0 5-2.239 5-5v-49c0-2.761-2.239-5-5-5h-43z",
    fill: "#bed9fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.001 443.99h43c2.761 0 5-2.239 5-5v-49c0-2.761-2.239-5-5-5h-43z",
    fill: "#bed9fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.001 235.99h43c2.761 0 5-2.239 5-5v-49c0-2.761-2.239-5-5-5h-43z",
    fill: "#bed9fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.905 280.99h24.096v59h-24.096z",
    fill: "#9ec8fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.905 384.99h24.096v59h-24.096z",
    fill: "#9ec8fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.905 176.99h24.096v59h-24.096z",
    fill: "#9ec8fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.079 123.549 92.017.324c2.761 0 5-2.239 5-5l1.905-6.882v-10.001c0-2.761-2.239-5-5-5h-71.001l-24.095 4.723z",
    fill: "#5f6c75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 111.99v10c0 2.761-2.239 5-5 5h-91l-3.543-15 3.543-15h20v10c0 2.761 2.239 5 5 5z",
    fill: "#4e5a61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.001 235.99h-53c-2.761 0-5-2.239-5-5v-49c0-2.761 2.239-5 5-5h53z",
    fill: "#bed9fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.001 339.99h-53c-2.761 0-5-2.239-5-5v-49c0-2.761 2.239-5 5-5h53z",
    fill: "#bed9fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.001 443.99h-53c-2.761 0-5-2.239-5-5v-49c0-2.761 2.239-5 5-5h53z",
    fill: "#bed9fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.001 126.99-86.671-4.47c-2.761 0-5-2.239-5-5l-2.149-14.496c0-2.761 2.239-5 5-5l7.819-1.034h81.001l7.5 17.566z",
    fill: "#5f6c75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 111.99 3.713 6.829-3.713 8.171h-91c-2.76 0-5-2.24-5-5v-20c0-2.76 2.24-5 5-5h10v10c0 2.76 2.24 5 5 5z",
    fill: "#4e5a61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.001 35v442l-4.607 12.798-294.393 2.553v-457.351l138.994-7.755z",
    fill: "#5f6c75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405 477v20h-35.04l-21.5-6.786-21.5 6.786h-31.64l-57.054-9.16-36.596 9.16h-30.67l-23.457-5.415-19.543 5.415h-42l10-20.032v-441.968l7.5-9.457 6.5 9.457v436c0 3.314 2.686 6 6 6z",
    fill: "#4e5a61"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bed9fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m163.5 74.5v47.05c0 1.1-.9 2-2 2h-24c-1.1 0-2-.9-2-2v-47.05c0-1.1.9-2 2-2h24c1.1 0 2 .9 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.5 140.55v47.05c0 1.1-.9 2-2 2h-24c-1.1 0-2-.9-2-2v-47.05c0-1.11.9-2 2-2h24c1.1 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.5 206.6v47.05c0 1.1-.9 2-2 2h-24c-1.1 0-2-.9-2-2v-47.05c0-1.11.9-2 2-2h24c1.1 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.5 272.65v47.04c0 1.11-.9 2-2 2h-24c-1.1 0-2-.89-2-2v-47.04c0-1.11.9-2 2-2h24c1.1 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m163.5 338.69v47.41c0 1.1-.9 2-2 2h-24c-1.1 0-2-.9-2-2v-47.41c0-1.1.9-2 2-2h24c1.1 0 2 .9 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.99 74.5v47.05c0 1.1-.89 2-2 2h-27.82c-1.1 0-2-.9-2-2v-47.05c0-1.1.9-2 2-2h27.82c1.11 0 2 .9 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.99 140.55v47.05c0 1.1-.89 2-2 2h-27.82c-1.1 0-2-.9-2-2v-47.05c0-1.11.9-2 2-2h27.82c1.11 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.99 206.6v47.05c0 1.1-.89 2-2 2h-27.82c-1.1 0-2-.9-2-2v-47.05c0-1.11.9-2 2-2h27.82c1.11 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.99 272.65v47.04c0 1.11-.89 2-2 2h-27.82c-1.1 0-2-.89-2-2v-47.04c0-1.11.9-2 2-2h27.82c1.11 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.99 338.69v47.41c0 1.1-.89 2-2 2h-27.82c-1.1 0-2-.9-2-2v-47.41c0-1.1.9-2 2-2h27.82c1.11 0 2 .9 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.81 74.5v47.05c0 1.1-.89 2-2 2h-27.82c-1.1 0-2-.9-2-2v-47.05c0-1.1.9-2 2-2h27.82c1.11 0 2 .9 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.81 140.55v47.05c0 1.1-.89 2-2 2h-27.82c-1.1 0-2-.9-2-2v-47.05c0-1.11.9-2 2-2h27.82c1.11 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.81 206.6v47.05c0 1.1-.89 2-2 2h-27.82c-1.1 0-2-.9-2-2v-47.05c0-1.11.9-2 2-2h27.82c1.11 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.81 272.65v47.04c0 1.11-.89 2-2 2h-27.82c-1.1 0-2-.89-2-2v-47.04c0-1.11.9-2 2-2h27.82c1.11 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.81 338.69v47.41c0 1.1-.89 2-2 2h-27.82c-1.1 0-2-.9-2-2v-47.41c0-1.1.9-2 2-2h27.82c1.11 0 2 .9 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.45 74.5v47.05c0 1.1-.89 2-2 2h-24c-1.1 0-2-.9-2-2v-47.05c0-1.1.9-2 2-2h24c1.11 0 2 .9 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.45 140.55v47.05c0 1.1-.89 2-2 2h-24c-1.1 0-2-.9-2-2v-47.05c0-1.11.9-2 2-2h24c1.11 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.45 206.6v47.05c0 1.1-.89 2-2 2h-24c-1.1 0-2-.9-2-2v-47.05c0-1.11.9-2 2-2h24c1.11 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.45 272.65v47.04c0 1.11-.89 2-2 2h-24c-1.1 0-2-.89-2-2v-47.04c0-1.11.9-2 2-2h24c1.11 0 2 .89 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.45 338.69v47.41c0 1.1-.89 2-2 2h-24c-1.1 0-2-.9-2-2v-47.41c0-1.1.9-2 2-2h24c1.11 0 2 .9 2 2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m401 30.734-307.776 2.192c-2.761 0-5-2.239-5-5l2.777-20.681c0-2.761 2.239-5 5-5l9.999-2.245h300.001c2.761 0 5 2.239 5 5v10l-5.001 10.734c0 2.762-2.239 5-5 5z",
    fill: "#5f6c75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411 15v15c0 2.76-2.24 5-5 5h-315c-2.76 0-5-2.24-5-5v-25c0-2.76 2.24-5 5-5h15v10c0 2.76 2.24 5 5 5z",
    fill: "#4e5a61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171 430.7v46.3l-.819 16.798-40.17.34.49-60.426c0-2.76 2.24-5 5-5l12.499-3.012h18c2.76 0 5 2.24 5 5z",
    fill: "#bed9fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.96 430.7v46.3l-1.481 17.138h-38.298l-.726-61.723c0-2.76 2.23-5 5-5l12.505-1.715h18c2.76 0 5 2.24 5 5z",
    fill: "#bed9fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.32 430.7v46.3l-2.415 17.138-88.17-1.787-.56-59.085c0-2.76 2.24-5 5-5l12.495-2.566h68.65c2.76 0 5 2.24 5 5z",
    fill: "#bed9fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171 477v20h-43v-66.3c0-2.761 2.239-5 5-5h15v46.3c0 2.761 2.239 5 5 5z",
    fill: "#9ec8fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.96 477v20h-43v-66.3c0-2.76 2.23-5 5-5h15v46.3c0 2.761 2.239 5 5 5z",
    fill: "#9ec8fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.32 477v20h-93.65v-66.3c0-2.761 2.239-5 5-5h15v46.3c0 2.761 2.239 5 5 5z",
    fill: "#9ec8fc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.721fbf9a6a54f35b81127426e4e60c9b.svg";
export { ForwardRef as ReactComponent };